import ErrorHandler from 'common/error/components/error-handler';
import SidePanel from 'common/side-panel/side-panel';
import { Tab, Tabs } from 'common/tabs';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'ui';
import useSockets from '../../../sockets/components/useSockets';
import { connectionStates } from '../../../utils/app-configs';
import ActionRequiredMessageContainer from '../containers/action-required-container';
import HistoryContainer from '../containers/history-container';
import messageCenterSockets from '../containers/message-center-sockets';

const StyledDiv = styled.div`
  height: 84px;
  padding: 25px 15px;
  text-align: right;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  vertical-align: middle;
`;

const MessageCenter = ({
  intl,
  error,
  isDismissing,
  dismissAllMessages,
  messages,
  toggleMessageCenter,
  messageCenterToggled,
  startPolling,
  fetchActionRequiredMessages,
}) => {
  const [activeTabKey, setActiveTabKey] = useState('1');
  const [connectionState] = useSockets(messageCenterSockets, ['useRealtimeEventsForMessageCenter']);

  const handleTabChange = newTabKey => setActiveTabKey(newTabKey);

  const closeMessageCenter = () => toggleMessageCenter(false);

  useEffect(() => {
    if (
      (connectionState === connectionStates.Error || connectionState === connectionStates.Closed) &&
      startPolling
    ) {
      startPolling();
    } else {
      fetchActionRequiredMessages();
    }
  }, [connectionState]);

  if (!messageCenterToggled) {
    return null;
  }

  return (
    <SidePanel
      width='45%'
      title={intl.formatMessage({ id: 'message_center.TITLE' })}
      onPanelClose={closeMessageCenter}
      scrollOnOverflow={false}
    >
      <ErrorHandler type='notification' error={error} />
      <Tabs
        shouldRenderAllTabs={false}
        activeTabKey={activeTabKey}
        tabChange={handleTabChange}
        needsPadding={false}
        boltTitle={true}
      >
        <Tab tabKey='1' title={intl.formatMessage({ id: 'message_center.TAB_1' })}>
          {messages && messages.length > 0 &&
            <StyledDiv>
              <Button
                data-test-id='dismiss-all-btn'
                type='secondary'
                disabled={isDismissing}
                onClick={dismissAllMessages}
                loading={isDismissing}
              >
                <FormattedMessage id='message_center.DISMISS_ALL' />
              </Button>
            </StyledDiv>
          }
          <ActionRequiredMessageContainer
            title='LOADING_MESSAGES'
            canDismiss={true}
            onRedirect={closeMessageCenter}
            offsetHeight={200}
            enableInfiniteScroll={false}
            connectionSuccess={connectionState === connectionStates.Connected}
          />
        </Tab>
        <Tab tabKey='2' title={intl.formatMessage({ id: 'message_center.TAB_2' })}>
          <HistoryContainer
            title='LOADING_HISTORY'
            canDismiss={false}
            onRedirect={closeMessageCenter}
            offsetHeight={116}
            enableInfiniteScroll={true}
          />
        </Tab>
      </Tabs>
    </SidePanel>
  );
};

MessageCenter.propTypes = {
  intl: PropTypes.object,
  error: PropTypes.object,
  isDismissing: PropTypes.bool,
  dismissAllMessages: PropTypes.func,
  messages: PropTypes.array,
  toggleMessageCenter: PropTypes.func,
  messageCenterToggled: PropTypes.bool,
  startPolling: PropTypes.func,
  fetchActionRequiredMessages: PropTypes.func,
};

export default injectIntl(MessageCenter);
